if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        ).forEach((element) => {
          element.classList.remove("is-active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add("is-active");
        activeMedia.scrollIntoView();

        const targetMediaWrapper = document.querySelector(
          `.media-wrapper:not([class*=" "])[data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"]`
        );
        if (targetMediaWrapper) {
          setTimeout(() => {
            targetMediaWrapper.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 500);
        }

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }
    }
  );
}
